import { useEffect, useState } from 'react';

const navItems = [
  { href: '#explore', label: '选片' },
  { href: '#hot', label: '热门推荐' },
  { href: '#douban', label: '豆瓣高分' },
  { href: '#word', label: '口碑电影' },
  { href: '#must', label: '必看电影' },
  { href: '#rank', label: '榜单' },
  { href: '#guide', label: '观影指南' },
];

export default function SiteNav() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled || menuOpen
          ? 'bg-background-50/95 backdrop-blur border-b border-background-200/80'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="h-16 md:h-[68px] flex items-center justify-between gap-4">
          <a href="#top" className="flex items-center gap-2.5 shrink-0">
            <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-film-line text-lg" aria-hidden="true"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className={`font-heading font-bold text-base md:text-lg ${scrolled || menuOpen ? 'text-foreground-950' : 'text-background-50'}`}>
                神马电影网
              </span>
              <span className={`text-[11px] mt-0.5 ${scrolled || menuOpen ? 'text-foreground-600' : 'text-background-200'}`}>
                什么电影好看 · 一页看全
              </span>
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-1" aria-label="页面分区导航">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className={`px-3 py-2 rounded-md text-sm font-medium transition-colors cursor-pointer ${
                  scrolled
                    ? 'text-foreground-700 hover:text-primary-700 hover:bg-primary-50'
                    : 'text-background-100 hover:text-background-50 hover:bg-white/10'
                }`}
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="#explore"
              className="hidden sm:inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-search-eye-line" aria-hidden="true"></i>
              开始选片
            </a>
            <button
              type="button"
              onClick={() => setMenuOpen((v) => !v)}
              aria-label="打开菜单"
              aria-expanded={menuOpen}
              className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer ${
                scrolled || menuOpen ? 'text-foreground-950 hover:bg-background-100' : 'text-background-50 hover:bg-white/10'
              }`}
            >
              <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`} aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="lg:hidden border-t border-background-200/80 bg-background-50">
          <nav className="px-4 py-3 grid grid-cols-2 gap-2" aria-label="移动端分区导航">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMenuOpen(false)}
                className="px-3 py-2.5 rounded-md text-sm font-medium text-foreground-700 bg-background-100 hover:bg-primary-50 hover:text-primary-700 transition-colors cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}